// src/pages/SpecialtyEnzymes.js
import React from 'react';
import ProductCategoryTemplate from '../components/templet/ProductCategoryTemplate';
import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import enzymes from '../assets/images/category/special enzymes.jpg';

const SpecialtyEnzymes = () => {
  const products = [
    {
      name: "Smoother Dough, Better Breads",
      category: "ENZYMES",
      description: "Alpha-amylase enzymes for superior dough handling and bread quality. Transform your bread production with enhanced machinability, improved crumb structure, and extended shelf-life.",
      features: [
        "Alpha-Amylase (Fungal) : Improves dough extensibility and machinability for easier processing",
        "Alpha-Amylase (Bacterial) : Provides sustained amylase activity throughout baking for better oven spring",
        "Maltogenic Amylase : Excellent anti-staling properties for extended bread softness"
      ],
      image: "/assets/images/amylase-enzymes.jpg"
    },
    {
      name: "Maximize Softness, Maximize Shelf Life",
      category: "ENZYMES",
      description: "Hemicellulase and Xylanase enzyme systems that revolutionize your bread texture and freshness. Achieve unparalleled softness while significantly extending shelf-life.",
      features: [
        "Hemicellulase (E.C. 3.2.1.4) : Breaks down hemicellulose for improved water absorption and dough development",
        "Xylanase (E.C. 3.2.1.8) : Modifies pentosans to enhance dough handling and increase loaf volume",
        "Improved crumb softness : Creates tender, fine-textured crumb that stays soft longer",
        "Extended shelf-life : Natural anti-staling mechanism keeps bread fresh for days"
      ],
      image: "/assets/images/hemicellulase.jpg"
    },
    {
      name: "Extract More From Your Flour",
      category: "ENZYMES",
      description: "Protease and Amyloglucosidase enzymes to maximize flour performance and reduce costs. Get more from every kilogram of flour while improving product quality.",
      features: [
        "Protease (E.C. 3.4.21.62) : Modifies gluten structure for improved extensibility and reduced mixing time",
        "Amyloglucosidase (E.C. 3.2.1.3) : Converts dextrins to fermentable sugars for enhanced yeast activity"
      ],
      image: "/assets/images/protease.jpg"
    },
    {
      name: "Sweet as Rise Higher",
      category: "ENZYMES",
      description: "Invertase and Glucose Oxidase for enhanced sweetness and superior oxidation. Create products with better color, flavor, and structural integrity.",
      features: [
        "Invertase : Converts sucrose into glucose and fructose for enhanced sweetness and moisture retention",
        "Glucose Oxidase : Natural oxidizing agent that strengthens gluten network and improves dough stability",
        "Anti-browning activity : Maintains product color and appearance during storage"
      ],
      image: "/assets/images/invertase.jpg"
    },
    {
      name: "Smoother Dough, Crisper Crust",
      category: "ENZYMES",
      description: "Lipolase and Laccase enzyme systems for optimized dough development and superior crust characteristics. Perfect for artisan breads and specialty products.",
      features: [
        "Lipolase (Lipase) : Modifies lipids to improve dough strength and gas retention",
        "Laccase : Crosslinks proteins for stronger dough and enhanced crust color and crispness"
      ],
      image: "/assets/images/lipolase.jpg"
    },
    {
      name: "Tender Texture, Easy Effort",
      category: "ENZYMES",
      description: "Transglutaminase (TG) for superior texture modification and protein cross-linking. Achieve professional results with minimal effort.",
      features: [
        "Transglutaminase (TG) : Creates protein bonds for improved texture and structure",
        "Enhanced elasticity : Develops strong, elastic dough that's easy to work with",
        "Improved water retention : Maintains moisture for softer, fresher products"
      ],
      image: "/assets/images/transglutaminase.jpg"
    },
    {
      name: "Strengthens Naturally, Performs Reliably",
      category: "ENZYMES",
      description: "Ascorbic Acid Oxidase and Glucose Oxidase for natural dough strengthening. Clean-label oxidation systems that deliver consistent results.",
      features: [
        "Ascorbic Acid Oxidase : Catalyzes ascorbic acid for natural dough strengthening",
        "Glucose Oxidase : Produces hydrogen peroxide in situ for gluten oxidation",
        "Clean-label solution : Natural alternative to chemical oxidizers",
        "Consistent performance : Reliable dough strengthening across varying conditions"
      ],
      image: "/assets/images/oxidase.jpg"
    },
    {
      name: "Say Goodbye to Stale Breads",
      category: "ENZYMES",
      description: "Anti-staling enzyme complex combining multiple enzyme activities for maximum freshness retention. Keep your breads soft and fresh for extended periods.",
      features: [
        "Multi-enzyme complex : Combines amylase, xylanase, and other activities",
        "Superior anti-staling : Significantly extends bread softness and freshness",
        "Improved crumb structure : Maintains texture throughout shelf-life"
      ],
      image: "/assets/images/anti-staling.jpg"
    },
    {
      name: "Keep Cakes Moist & Delightful",
      category: "ENZYMES",
      description: "Specialized enzyme systems for cake applications. Maintain moisture, enhance texture, and extend freshness in all your cake products.",
      features: [
        "Maltogenic Amylase : Prevents starch retrogradation in cakes",
        "Alpha-Amylase (Fungal) : Improves cake texture and eating quality",
        "Enhanced moisture retention : Keeps cakes moist and tender longer"
      ],
      image: "/assets/images/cake-enzymes.jpg"
    },
    {
      name: "Bake Bold, Crust Golden",
      category: "ENZYMES",
      description: "Enzyme systems specifically designed for crust color and flavor development. Achieve that perfect golden-brown crust with enhanced flavor complexity.",
      features: [
        "Alpha-Amylase : Produces reducing sugars for Maillard reaction",
        "Protease : Creates amino acids for enhanced browning and flavor",
        "Improved crust color : Develops attractive, golden-brown crust color",
        "Enhanced flavor : Complex flavors from Maillard reaction products"
      ],
      image: "/assets/images/crust-enzymes.jpg"
    },
    {
      name: "Master White Wheat With Ease",
      category: "ENZYMES",
      description: "Specialized enzyme solutions for whole wheat and multigrain formulations. Overcome the challenges of bran and achieve excellent volume and texture.",
      features: [
        "Xylanase : Modifies pentosans in bran for better water absorption",
        "Hemicellulase : Breaks down fiber for improved dough development",
        "Enhanced volume : Achieves good loaf volume despite bran presence",
        "Improved texture : Softer crumb despite high fiber content"
      ],
      image: "/assets/images/whole-wheat-enzymes.jpg"
    }
  ];

  const relatedCategories = [
    {
      title: "Bread Improvers & Dough Conditioners",
      description: "Complete improver systems.",
      itemCount: 12,
      image: image2,
      link: "/products/bread-improvers"
    },
    {
      title: "Premixes & Concentrates",
      description: "All-in-one solutions.",
      itemCount: 14,
      image: image3,
      link: "/products/premixes"
    },
    {
      title: "Shelf-Life Enhancers & Preservatives",
      description: "Freshness solutions.",
      itemCount: 10,
      image: image4,
      link: "/products/shelf-life"
    },
    {
      title: "Emulsifiers & Texture Improvers",
      description: "Texture enhancement.",
      itemCount: 8,
      image: image5,
      link: "/products/emulsifiers"
    },
    {
      title: "Leavening Agents (Raising Agents)",
      description: "Perfect rise solutions.",
      itemCount: 13,
      image: image6,
      link: "/products/leavening"
    },
    {
      title: "Other Ingredients: Starches, Gums, Flavors",
      description: "Specialty solutions.",
      itemCount: 20,
      image: image7,
      link: "/products/other-ingredients"
    },
    {
      title: "Quality Assurance",
      description: "Guaranteed quality.",
      itemCount: null,
      image: image8,
      link: "/quality"
    },
    {
      title: "View All",
      description: "All products.",
      itemCount: null,
      image: image9,
      link: "/products"
    }
  ];

  return (
    <ProductCategoryTemplate
      title="Specialty Enzymes"
      description="Transform your dough quality and reduce dependency on chemical additives. Our precision-engineered enzyme solutions offer natural, effective ways to enhance your baking processes and product quality."
      heroImage={enzymes}
      products={products}
      relatedCategories={relatedCategories}
    />
  );
};

export default SpecialtyEnzymes;